import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { CmsModule } from '@fcom/cms/components';
import { ComponentsModule, DirectiveModule, FinFormsModule, FragmentService, PipesModule } from '@fcom/common';
import { PnrWidgetModule } from '@fcom/pnr-widget/pnr-widget.module';
import { GtmModule } from '@fcom/common/gtm';

import { CheckInFormComponent } from './components/check-in-form/check-in-form.component';
import { CheckInEntryRouteComponent } from './routes/check-in-entry-route.component';
import { ManageBookingCommonModule } from '../common/booking-common.module';

@NgModule({
  imports: [
    CmsModule,
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    FinFormsModule,
    PipesModule,
    UiTranslateModule,
    UiComponentsModule,
    FinFormsModule,
    PnrWidgetModule,
    GtmModule,
    ManageBookingCommonModule,
  ],
  declarations: [CheckInEntryRouteComponent, CheckInFormComponent],
  exports: [CheckInEntryRouteComponent],
  providers: [FragmentService],
})
export class CheckInEntryModule {}
